<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">

      <div *ngIf="ordersExist" class="spacing spacing--sm">
        Below is a summary of orders for the current year. See {{ this.availableProducts }} registrations by clicking
        the buttons below (or selecting the corresponding menu option).
      </div>
      <div *ngIf="!ordersExist" class="spacing spacing--sm">
        There are no orders for the current year at this time. See {{ this.availableProducts }} registrations by
        selecting the corresponding menu option.
      </div>
      <div class="spacing">
        Invoicing for the following orders will occur after the close of the registration period.
      </div>
      <div *ngIf="!loading">
        <aaos-products-table *ngFor="let product of productsAndOrders | keyvalue" [orders]="product">
        </aaos-products-table>
      </div>
    </div>
  </div>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
